import { STORAGE_KEY_PREFIX } from './constants';

const getStorageKey = chatId => `${STORAGE_KEY_PREFIX}${chatId}`;

export const readDraft = chatId => {
  if (!chatId || typeof window === 'undefined') {
    return '';
  }

  return window.localStorage.getItem(getStorageKey(chatId)) ?? '';
};

export const writeDraft = (chatId, value) => {
  if (!chatId || typeof window === 'undefined') {
    return;
  }

  const key = getStorageKey(chatId);

  if (value) {
    window.localStorage.setItem(key, value);

    return;
  }

  window.localStorage.removeItem(key);
};
